var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawMetrics5V8D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 954.39,
    height: 711.251,
    viewBox: "0 0 954.39 711.251",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-412.841 -96.017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,562.07c0,.66.285,1.19.64,1.19H288.59c.355,0,.64-.53.64-1.19s-.285-1.19-.64-1.19H.64C.285,560.88,0,561.41,0,562.07Z",
    transform: "translate(1078 244.009)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1131 244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.653,308.7c-1.69,8.48-7.72,13.98-13.47,12.28s-9.04-9.96-7.35-18.44a19.109,19.109,0,0,1,4.32-9.07l7.63-35.8,17.84,5.88-9.42,34.67a21.483,21.483,0,0,1,.43,10.48h0Z",
    transform: "translate(-285.09 0.009)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.94,
    height: 29.71,
    transform: "translate(40.833 514.389)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.242,561.11c3.58.32,21.5,1.74,22.4-2.37a17.609,17.609,0,0,0-.56-8.25c-1.72-17.14-2.36-17.33-2.75-17.44-.61-.18-2.39.67-5.28,2.53l-.18.12-.04.21c-.05.27-1.33,6.56-7.4,5.59-4.16-.66-5.51-1.58-5.94-2.03a2.559,2.559,0,0,0,1.1-.92,3.218,3.218,0,0,0,.23-2.68,41.639,41.639,0,0,0-3.22-7.23l-.27-.48-23.8,16.06-14.7,4.2a3.787,3.787,0,0,0-2.45,2.17h0a3.791,3.791,0,0,0,.96,4.28c2.67,2.4,7.97,6.51,13.54,7.02,1.48.14,3.44.19,5.64.19,9.19,0,22.61-.95,22.71-.97Z",
    transform: "translate(-250.088 0.009)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.94,
    height: 29.71,
    transform: "translate(98.844 514.389)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.232,561.11c3.58.32,21.5,1.74,22.4-2.37a17.609,17.609,0,0,0-.56-8.25c-1.72-17.14-2.36-17.33-2.75-17.44-.61-.18-2.39.67-5.28,2.53l-.18.12-.04.21c-.05.27-1.33,6.56-7.4,5.59-4.16-.66-5.51-1.58-5.94-2.03a2.559,2.559,0,0,0,1.1-.92,3.218,3.218,0,0,0,.23-2.68,41.638,41.638,0,0,0-3.22-7.23l-.27-.48-23.8,16.06-14.7,4.2a3.787,3.787,0,0,0-2.45,2.17h0a3.791,3.791,0,0,0,.96,4.28c2.67,2.4,7.97,6.51,13.54,7.02,1.48.14,3.44.19,5.64.19,9.19,0,22.61-.95,22.71-.97Z",
    transform: "translate(-134.068 0.009)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.58,100.28l-32.47,10.67V64.21h29.46Z",
    transform: "translate(-142.766 0.009)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.35,
    cy: 32.35,
    rx: 32.35,
    ry: 32.35,
    transform: "translate(42.013 12.459)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.585,47.33l-4.46,5.41-8.07-14.12s-10.3.53-10.3-7.11-9.45-7.86-9.45-7.86S189.935.3,217.635,6.45c0,0,19.21-13.16,28.77-1.91,0,0,29.3,14.75,20.91,40.44l-13.93,26.48-3.16-5.99s1.91-25.16-14.65-18.15Z",
    transform: "translate(-152.981 0.009)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.73,254.19H283L256.26,529.88l-31-2-1.53-198.54-19.51,87.13-5.71,109.91-28.25,1.5-3.28-125.03Z",
    transform: "translate(-134.056 0.009)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.61,83.19l-37,9L166.98,228.88l3.72,25.31,92.65,15.68,16.62-15.68Z",
    transform: "translate(-131.026 0.009)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.34,82.313l13.275,8.227,25.66,6.16L237,305.5H177.725l-23.48-198.11Z",
    transform: "translate(-75.321 0.009)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.669,91.325l6.361,15.635L257.48,317.88H241.72l7.27-206.4,21.4-17Z",
    transform: "translate(-213.826 0.009)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.28,108.87l-12.69,2.61s-5.56,2.04-7.58,17.84-2.37,68.86-2.37,68.86l-21.58,85.6,24.51,8.08,11.54-46.06,8.18-136.94Z",
    transform: "translate(-264.426 0.009)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.613,275.51c-5.15,6.95-12.95,9.34-17.42,5.35s-3.92-12.86,1.23-19.82a18.978,18.978,0,0,1,7.79-6.35l22.2-29.11,13.62,12.94L183.7,265.84a21.526,21.526,0,0,1-4.09,9.66h0Z",
    transform: "translate(-50.279 0.009)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.63,99.89l10.14-3.19s13.74,3.41,18.29,20.57l22.21,83.6L152.6,266.99l-20.13-24.44,18.96-60.7L139.62,99.89Z",
    transform: "translate(-6.816 0.009)",
    fill: "#2f2e43"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(634.5 -87.562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M533.873,501.612c.036,0,.072,0,.109,0a72.885,72.885,0,0,0,1.631-145.467,1.663,1.663,0,0,0-1.258.436,1.645,1.645,0,0,0-.538,1.2l-1.594,142.145a1.668,1.668,0,0,0,1.65,1.683Z",
    transform: "translate(-79.433 249.12)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.712,379.647a2.146,2.146,0,0,1,1.506.643l48.935,50.044a2.123,2.123,0,0,1,.609,1.518L527,499.87a2.115,2.115,0,0,1-.691,1.549,2.148,2.148,0,0,1-1.615.561,73.362,73.362,0,0,1-49.612-121.606,2.149,2.149,0,0,1,1.551-.725Z",
    transform: "translate(-79.433 249.12)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.471,355.561a2.155,2.155,0,0,1,1.464.6,2.117,2.117,0,0,1,.657,1.566l-.688,61.369a2.137,2.137,0,0,1-3.664,1.47l-42.7-43.67a2.141,2.141,0,0,1,.036-3.028q.039-.038.079-.074a73.516,73.516,0,0,1,44.685-18.229C526.383,355.562,526.427,355.561,526.471,355.561Z",
    transform: "translate(-79.433 249.12)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1129.451,886.131H692.839A39.077,39.077,0,0,1,653.806,847.1V213.912a39.077,39.077,0,0,1,39.033-39.033h436.611a39.077,39.077,0,0,1,39.033,39.033V847.1a39.077,39.077,0,0,1-39.033,39.033Z",
    transform: "translate(-240.966 -78.862)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.1,852.57H682.952a12.046,12.046,0,0,1-12.032-12.032V203.158a12.046,12.046,0,0,1,12.032-12.032H1121.1a12.046,12.046,0,0,1,12.032,12.032V840.538A12.046,12.046,0,0,1,1121.1,852.57Z",
    transform: "translate(-231.92 -70.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.32,
    cy: 3.321,
    rx: 3.32,
    ry: 3.321,
    transform: "translate(665.198 104.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1060.066,524.549H706.86a1.105,1.105,0,0,1-1.105-1.105V354.151a1.105,1.105,0,0,1,2.211,0V522.338h352.1a1.105,1.105,0,1,1,0,2.211Z",
    transform: "translate(-213.284 16.077)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.016,474.673H735.89a3.285,3.285,0,0,1-3.281-3.281V427.107a3.285,3.285,0,0,1,3.281-3.281h32.125a3.285,3.285,0,0,1,3.281,3.281v44.285a3.285,3.285,0,0,1-3.281,3.281Z",
    transform: "translate(-198.975 53.793)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.235,489.275H774.109a3.285,3.285,0,0,1-3.281-3.281V399.7a3.285,3.285,0,0,1,3.281-3.281h32.125a3.285,3.285,0,0,1,3.281,3.281v86.289a3.285,3.285,0,0,1-3.281,3.281Z",
    transform: "translate(-178.609 39.192)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.454,474.673H812.328a3.285,3.285,0,0,1-3.281-3.281V427.107a3.285,3.285,0,0,1,3.281-3.281h32.125a3.285,3.285,0,0,1,3.281,3.281v44.285a3.285,3.285,0,0,1-3.281,3.281Z",
    transform: "translate(-158.243 53.793)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.673,495.039H850.547a3.213,3.213,0,0,1-3.281-3.132V388.739a3.213,3.213,0,0,1,3.281-3.132h32.125a3.213,3.213,0,0,1,3.281,3.132V491.907A3.213,3.213,0,0,1,882.673,495.039Z",
    transform: "translate(-137.877 33.427)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.892,505.414H888.766a3.285,3.285,0,0,1-3.281-3.281V369.418a3.285,3.285,0,0,1,3.281-3.281h32.125a3.285,3.285,0,0,1,3.281,3.281V502.133a3.285,3.285,0,0,1-3.281,3.281Z",
    transform: "translate(-117.512 23.053)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.632,
    cy: 6.632,
    rx: 6.632,
    ry: 6.632,
    transform: "translate(546.346 451.091)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.632,
    cy: 6.632,
    rx: 6.632,
    ry: 6.632,
    transform: "translate(604.932 407.981)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.632,
    cy: 6.632,
    rx: 6.632,
    ry: 6.632,
    transform: "translate(663.516 451.091)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.632,
    cy: 6.632,
    rx: 6.632,
    ry: 6.632,
    transform: "translate(722.1 386.979)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.632,
    cy: 6.632,
    rx: 6.632,
    ry: 6.632,
    transform: "translate(780.686 362.66)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.336,268.3l-58.724-43.984L535.689,267.7l-1.326-1.769,59.248-44.378,58.445,43.777,58.077-63.557.235-.1,58.585-23.6.826,2.051-58.352,23.511Z",
    transform: "translate(17.952 190.907)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M832.037,309.282c7.608,0,13.787,1.946,13.787,4.337v33.749c0,2.393-6.185,4.337-13.787,4.337H504.194c-7.608,0-13.787-1.946-13.787-4.337V313.621c0-2.393,6.185-4.337,13.787-4.337",
    transform: "translate(2.063 362.695)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.037,309.282c7.608,0,13.787,1.946,13.787,4.337v33.749c0,2.393-6.185,4.337-13.787,4.337H504.194c-7.608,0-13.787-1.946-13.787-4.337V313.621c0-2.393,6.185-4.337,13.787-4.337",
    transform: "translate(2.063 303.695)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 73,
    r: 73,
    transform: "translate(597 171)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.128,673H870.39v-9.738a3.652,3.652,0,0,0-7.3,0V673h-9.738a3.652,3.652,0,0,0,0,7.3h9.738v9.738a3.652,3.652,0,1,0,7.3,0v-9.738h9.738a3.652,3.652,0,0,0,0-7.3Z",
    transform: "translate(-196.738 -432.656)",
    fill: "#6c63ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawMetrics5V8D);
export default __webpack_public_path__ + "static/media/undraw_metrics_5v8d.1ce0b389ca7fb41f6adb1b6085a30636.svg";
export { ForwardRef as ReactComponent };